import { Button, Grid, TextField, InputAdornment } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from "react";
import { setGlobalState, useGlobalState } from '../../../globalStyle';
import CloseIcon from "@mui/icons-material/Close";

const CouponCode = ({ productDetails, setCouponDetailsData, isActivePlan, initialState, setProductPlanId, setSuggestPlanId, setIsCouponCodeDisplay }) => {
    const [couponCode, setCouponCode] = useState("");
    const [couponCodeMessage, setCouponCodeMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [buttonDisabled, setIsButtonDisabled] = useState(false);
    const [couponAfterSuccessMessage, setCouponAfterSuccessMessage] = useState("");
    const ogPlanId = useGlobalState("ogPlanId")[0];
    const paymentBaseUrl = useGlobalState("PAYMENTBASEURL")[0];

    useEffect(() => {
        setTimeout(() => {
            setIsError(false);
        }, 60000);
    }, [isError]);

    const handleCouponCodeChange = (event) => {
        setCouponCode(event.target.value);
        if (event.target.value === "") {
            setGlobalState("selectedPlanId", ogPlanId);
            setCouponCode("");
            setIsError(false);
            setIsButtonDisabled(false);
            setCouponDetailsData("");
            setCouponCodeMessage("");
            setCouponAfterSuccessMessage("");
            setGlobalState('offerPrice', "");
            setIsButtonDisabled(false);
            setGlobalState("isValidCouponCode", false);
        }
    };

    const handleSubmit = async () => {
        try {
            const response = await axios.get(`${paymentBaseUrl}/api/payment/coupon-code?planId=${productDetails.code}&couponCode=${couponCode}&clientCode=${initialState.client_code ? initialState.client_code : initialState.client_mobile}`);
            // const response = await axios.get(`http://localhost:4000/dev/api/payment/coupon-code?planId=${productDetails.code}&couponCode=${couponCode}&clientCode=${initialState.client_code ? initialState.client_code : initialState.client_mobile}`);
            if (response.data.data && response.data.data[0].plan_amount.hasOwnProperty(productDetails.code)) {
                const message = response.data.data[0].message;
                if (message) {
                    setCouponAfterSuccessMessage(message);
                } else {
                    setCouponAfterSuccessMessage("");
                }
                setCouponCodeMessage("Congratulations, the coupon code has been applied 🎉🎊");
                setIsError(true);
                setGlobalState("isValidCouponCode", true);
                setCouponDetailsData(response.data.data[0]);
                setIsButtonDisabled(true);
                setGlobalState('offerPrice', response.data.data[0].plan_amount[productDetails.code]);
                setProductPlanId("selectedPlanId", Object.keys(response.data.data[0].plan_amount)[0]);
                setSuggestPlanId("suggestedPlanId", Object.keys(response.data.data[0].plan_amount)[0]);
            } else {
                setCouponDetailsData([]);
                setCouponAfterSuccessMessage("");
                setCouponCodeMessage("No coupon available for this plan");
                setIsError(true);
                setIsButtonDisabled(false);
                setGlobalState('offerPrice', "");
                setGlobalState("isValidCouponCode", false);
            }
        } catch (error) {
            if (error.response.data.planId) {
                setGlobalState("selectedPlanId", Object.keys(error.response.data.planId)[0]);
                setGlobalState("isValidCouponCode", true);
                setGlobalState('offerPrice', Object.values(error.response.data.planId)[0]);
                setGlobalState("showConfetti", true);
                setGlobalState("suggestedPlanId", Object.keys(error.response.data.planId)[0])
                setIsError(true);
                setCouponAfterSuccessMessage(error.response.data.data.message);
                setCouponCodeMessage(error.response.data.message);
                setCouponDetailsData(error.response.data.data);
                setIsButtonDisabled(true);
            } else {
                setIsError(true)
                setCouponCodeMessage(error.response.data.message);
                setIsButtonDisabled(false);
                setGlobalState("isValidCouponCode", false);
            }
        }
    };

    return (
        <div style={{ marginTop: "5px" }}>
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={11} md={11} sm={11}>
                    <TextField
                        style={{ paddingRight: 0 }}
                        size="small"
                        disabled={isActivePlan}
                        id="couponCode"
                        label="Coupon Code"
                        placeholder="Enter coupon code"
                        fullWidth
                        margin="dense"
                        value={couponCode}
                        onChange={handleCouponCodeChange}
                        InputProps={{
                            inputProps: {
                                style: {
                                    color: 'black',
                                    fontWeight: 600
                                }
                            },
                            endAdornment: (
                                <InputAdornment position="end" sx={{ p: 0 }}>
                                    <div style={{
                                        borderLeft: '2px solid #e0e0e0',
                                        padding: '5px',
                                        cursor: 'pointer',
                                        padding: "0px 5px 0px 10px",
                                        color: buttonDisabled || !couponCode || isActivePlan ? "gray" : "blue", // Change color to gray when disabled
                                        fontWeight: 700
                                    }}>
                                        <div
                                            disabled={!couponCode || isActivePlan || buttonDisabled}
                                            onClick={handleSubmit}
                                            style={{ pointerEvents: buttonDisabled || !couponCode || isActivePlan ? "none" : "auto" }} // Disable pointer events when disabled
                                        >
                                            {buttonDisabled ? "Coupon applied" : "Apply Coupon"}
                                        </div>
                                    </div>
                                </InputAdornment>
                            ),
                        }}
                    />

                </Grid>
                <Grid item xs={1} md={1} sm={1}>
                    <div style={{ cursor: "pointer" }} onClick={() => setIsCouponCodeDisplay(false)}>
                        <CloseIcon size="small" /></div></Grid>
                <div className='coupon-note-wrapper'>
                    <div className='coupon-code-success-message'>
                        {isError ? <div>{couponCodeMessage}</div> : ""}
                    </div>

                    <div className='coupon-code-after-success-message'>
                        <div>{couponAfterSuccessMessage}</div>
                    </div>
                </div>
            </Grid>
        </div>
    );
};

export default CouponCode;
